<template>
    <v-app>
        <v-main>
            <v-row>
                <v-col>
                    <v-card>
                        <v-card-title>
                            <span class="headline">Page Details</span>
                        </v-card-title>
                        <v-card-text>
                            <v-simple-table>
                                <template v-slot:default>
                                    <tbody>
                                        <template v-for="(item, index) in page">
                                            <tr :key="index" v-if="!switches.map(x => x.name).includes(index)">
                                                <td>{{ index }}</td>
                                                <td>{{ item !== null ? item : 'None' }}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-card>
                        <v-card-title>
                            <span class="headline">Page Actions</span>
                        </v-card-title>
                        <v-card-text>
                            <v-switch
                                v-for="(item, index) in switches"
                                :key="item.name"
                                v-model="item.value"
                                :label="item.label"
                                :loading="item.loading"
                                :disabled="item.loading"
                                @change="updatePage(index)"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-card>
                        <v-card-title>
                            <span class="headline">Page Users</span>
                        </v-card-title>
                        <v-card-text>
                            <v-simple-table v-for="(user, userIndex) in users" :key="userIndex">
                                <template v-slot:default>
                                    <tbody>
                                        <tr v-for="(item, index) in user" :key="index">
                                            <td>{{ index }}</td>
                                            <td>{{ item !== null ? item : 'None' }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-main>
    </v-app>
</template>
<script>
export default {
    data() {
        return {
            users: [],
            switches: [
                {
                    name: 'show_on_home',
                    label: 'Show on landing page',
                    loading: false,
                    value: false,
                },
                {
                    name: 'hall_of_fame_enabled',
                    label: 'Enable Hall of Fame',
                    loading: false,
                    value: false,
                },
            ],
        };
    },

    props: {
        'page': Object,
    },

    created() {
        this.users = this.page.users;
        delete this.page.users;
        this.users.forEach(user => {
            for (const [key, value] of Object.entries(user.pivot)) {
                user[key] = value;
            }
            delete user.page_id;
            delete user.user_id;
            delete user.pivot;
        });
        this.switches.forEach(switchItem => {
            switchItem.value = this.page[switchItem.name];
        });
    },

    methods: {
        updatePage(key) {
            this.switches[key].loading = true;
            axios.put(`/api/developer/pages/${this.page.url_prefix}`, {
                [this.switches[key].name]: this.switches[key].value,
            }).then(response => {
                this.page[this.switches[key].name] = this.switches[key].value;
            }).catch(error => {
                this.switches[key].value = this.page[this.switches[key].name];
                console.log(error);
            }).finally(() => {
                this.switches[key].loading = false;
            });
        },
    },
};
</script>
